import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import queryString from "query-string";
import PrintComponents from "react-print-components";
import PropTypes from "prop-types";
import { postSubmitApi, newAgreement } from "./actions";
import { prepareRender } from "./summaryConfig";
import { ConfirmTerms } from "./Components/LanguageComponent";
import Preloader from "../../../../CommonComponents/Preloader/Preloader";
import { getPrimaryAccount } from "../../../../utils/sessionUtil";
import { FixedWidth } from "../../../../CommonComponents/commonStyles";
import { GrantAgreementHeading, SectionMediumDivider, Block } from "./styles";
import { fetchAccountAdvisors } from "../../../../actions/globalActions";
import Step3Summary from "./Steps/EditAndReviewGrant/Step3Summary";
import ViewRecurSchedule from "../RecommendGrant/Component/ViewEditSchedules/Components/ViewRecurSchedule";
import Step1Summary from "../RecommendGrant/Component/ViewEditSchedules/Components/Step1Summary";
import Step2Summary from "../RecommendGrant/Component/ViewEditSchedules/Components/Step2Summary";
import PermissionToPublish from "../RecommendGrant/Component/ViewEditSchedules/Components/PermissionToPublish";
import { GrantGhostButton } from "../RecommendGrant/style";
import BreadcrumbComponent from "../../../../CommonComponents/Breadcrumb/Breadcrumb";
import PageAccountSummary from "../../../../CommonComponents/PageSummary/PageAccountSummary/PageAccountSummary";
import {
  ConfirmationNotes,
  ConfirmationRules,
  StyleLessButton,
} from "./styles";
import { IconPadding, DataExportPrint } from "../../../MyAccounts/styles";
import printIcon from "../../../../assets/icons/print.svg";
import PreviewLetters from "./Components/ReviewAndSubmit/Components/PreviewLetter/PreviewLetters";
import PagePrintButton from "../../../../CommonComponents/PrintButton/PagePrintButton";
import ConfirmationPagePrint from "./ConfirmationPagePrint";
import {
  milliToDate,
  dateFormatter,
  recordError,
} from "../../../../utils/commonUtil";
import Heading from "../RecommendGrant/Component/ViewEditSchedules/Components/Heading.js";
import { StatusSection } from "../RecommendGrant/style";
import InfoInline from "../RecommendGrant/Component/ViewEditSchedules/Components/InfoInline";
import {
  ContentProvider,
  Types,
  ContentMessage,
} from "../../../../CommonComponents/ContentMessages";
import CharityDetailSummary from "./Components/StepOneSummary/CharityDetailSummary";
import PurposeRecognition from "./Components/StepOneSummary/PurposeSummary";

import { confirmationPageDerivedStates } from './Selectors/ConfirmationPageSelectors';

export class ConfirmationPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formattedPayments: [],
    };
  }

  getGrantAgreementApi() {
    const { grantAgreementId, grantId } = queryString.parse(
      this.props.location.search
    );
    const agreementId = grantId ? grantId : grantAgreementId;
    const data = {
      method: "GET",
      page: "grantAgreements",
      url: `/donor-portal/api/grantAgreement/${
        getPrimaryAccount().userId
      }/findGrantAgreementByAccountIdAndGrantAgreementId?grantAgreementId=${agreementId}`,
    };
    this.props.getGrantAgreementData(data);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.newAgreement();
    this.getGrantAgreementApi();
    this.props.fetchAdvisors({ accountId: getPrimaryAccount().userId });
  }

  componentDidUpdate(nextProps) {
    if (this.props.advisors !== nextProps.advisors) {
      this.setState({ advisors: nextProps.advisors });
    }
  }

  static getDerivedStateFromProps(props, state) {
    let paymentData = [];
    if (props.payments.length && props.payments !== state.formattedPayments) {
      props.payments.forEach((payment) => {
        paymentData.push({
          ...payment,
          intendedPaymentDate: dateFormatter(payment.intendedPaymentDate),
          isReportingRequired:
            payment.isReportingRequired === "No" ? false : true,
          isPaymentContingent:
            payment.isReportingRequired === "No"
              ? ""
              : payment.isPaymentContingent,
          /** Format requirement due date, only when it is not null */
          requirementDueDate: payment.requirementDueDate
            ? dateFormatter(payment.requirementDueDate)
            : null,
        });
      });
    }
    return { formattedPayments: paymentData };
  }

  breadcrumbRoutes = () => {
    if (this.props.isGrantView) {
      return [
        {
          routeName: "Home",
          path: "/",
        },
        {
          routeName: "Grants",
          path: "/grants",
        },
        {
          routeName: "Grant Activity",
          path: "/grants/activity",
        },
        {
          routeName: "View Grant Agreement",
          path: "",
        },
      ];
    }
    return [
      {
        routeName: "Home",
        path: "/",
      },
      {
        routeName: "Grants",
        path: "/grants",
      },
      {
        routeName: "Grant Agreements",
        path: "/grants/agreement",
      },
    ];
  };

  goToPage = (tab) => {
    try {
      this.props.history.push({
        pathname: `/grants/activity`,
        state: { grantTab: tab },
      });
    } catch (error) {
      recordError(error);
    }
  };

  contactDetailRender = () => ({
    contactName: this.props.contact.charityContactFirstName,
    contactLastName: this.props.contact.charityContactLastName,
    contactPhoneNumber: this.props.contact.phoneNumber,
    contactEmail: this.props.contact.email,
  });

  paymentFormatter = () => {
    return (
      this.props.payments.length &&
      this.props.payments.map((item, index) => ({
        grantAmountStr: item.paymentAmount,
        intendedPaymentDate: item.intendedPaymentDate,
        reportRequirement: item.isReportingRequired === "Yes" ? true : false,
        requirementType: item.requirementType,
        grantRequirementDueDate: item.requirementDueDate,
        isContingent: item.isPaymentContingent,
      }))
    );
  };

  render() {
    const {
      payments,
      startDate,
      noOfPayments,
      grantAgreementId,
      contact,
      purpose,
      grantAgreementAmount,
      recognition,
      codeValueMappingData,
      grantAgreementEnteredDate,
    } = this.props;
    const { accountName, accountNumber } = getPrimaryAccount();
    const printRef = React.createRef();
    if (!noOfPayments && !payments.length && !startDate && !Object.keys(contact).length && !Object.keys(purpose).length)
      return <Preloader />;
    const contactProps = {
      ...this.contactDetailRender(),
    };

    const {
      charityInfo,
      purposeRecognition,
      publishName,
      amountAllocation,
      scheduleData,
    } = prepareRender({ ...this.props, invalidAllocation: false });

    let address =
      contact.addressLine1 +
      contact.addressLine2 +
      contact.addressLine3 +
      contact.state +
      contact.city +
      contact.zip;

    return (
      <ContentProvider
        types={[Types.GET_CONFIRMATION_MESSAGE]}
        pages={["Grant Agreement Confirmation"]}
      >
        <FixedWidth>
          <BreadcrumbComponent breadcrumbRoutes={this.breadcrumbRoutes()} />
          <div ref={printRef}>
            {this.props.isGrantView ? (
              <GrantAgreementHeading>
                Agreement ID: {grantAgreementId}
              </GrantAgreementHeading>
            ) : (
              <GrantAgreementHeading>
                <ContentMessage
                  type={[Types.GET_CONFIRMATION_MESSAGE]}
                  page={"Grant Agreement Confirmation"}
                  property="field_page_title"
                  defaultMessage={"Grant Agreement Confirmation"}
                />
              </GrantAgreementHeading>
            )}
            {this.props.isGrantView ? null : (
              <>
                <SectionMediumDivider smallMarginTop smallMarginBottom />
                <ConfirmTerms />
                <SectionMediumDivider smallMarginTop smallMarginBottom />
              </>
            )}
            {this.props.isGrantView && (
              <div className="mt-30">
                <PageAccountSummary
                  key="accountName"
                  label={accountName}
                  value={accountNumber}
                  dataName="accountName"
                />
              </div>
            )}
            <Block flex={window.screen.width < 576 ? 2 : null} fixEnds alignTop>
              <Block flex={2}>
                {this.props.isGrantView ? (
                  <>
                    <StatusSection>
                      <InfoInline
                        title="Entered Date:"
                        value={dateFormatter(grantAgreementEnteredDate)}
                        wordBreakOnly={true}
                      />
                      <InfoInline
                        title="Status:"
                        value={
                          this.props.status && this.props.status.description
                            ? this.props.status.description
                            : "--"
                        }
                        wordBreakOnly={true}
                      />
                    </StatusSection>
                  </>
                ) : (
                  <>
                    <Block>
                      <ConfirmationRules>
                        Grant Agreement ID:&nbsp;
                      </ConfirmationRules>
                      <ConfirmationNotes>{grantAgreementId}</ConfirmationNotes>
                    </Block>
                    <Block>
                      <ConfirmationRules>Entered Date:&nbsp;</ConfirmationRules>
                      <ConfirmationNotes lineHeight>
                        {dateFormatter(grantAgreementEnteredDate)}
                      </ConfirmationNotes>
                    </Block>
                  </>
                )}
              </Block>
              <PrintComponents
                className="i_print"
                trigger={
                  <StyleLessButton>
                    <IconPadding>
                      <img src={printIcon} alt="print_Image" />
                      <DataExportPrint>
                        <a>PRINT</a>
                      </DataExportPrint>
                    </IconPadding>
                  </StyleLessButton>
                }
              >
                <ConfirmationPagePrint
                  grantAgreementId={grantAgreementId}
                  dateFormatter={dateFormatter}
                  grantAgreementEnteredDate={grantAgreementEnteredDate}
                  charityInfo={charityInfo}
                  purposeRecognition={purposeRecognition}
                  codeValueMappingData={codeValueMappingData}
                  publishName={publishName === "Yes" ? true : false}
                  amountAllocation={amountAllocation}
                  scheduleType={this.props.scheduleType}
                  scheduleData={scheduleData}
                  formattedPayments={this.state.formattedPayments}
                  isGrantView={this.props.isGrantView}
                  status={
                    this.props.status && this.props.status.description
                      ? this.props.status.description
                      : "--"
                  }
                  accountName={accountName}
                  accountNumber={accountNumber}
                />
              </PrintComponents>
              {/* Commented as per bugfix/OW-346 - white space issues
              <StyleLessButton>
                <PagePrintButton
                  className='ml-auto'
                  contentRef={() => printRef.current}
                />
              </StyleLessButton> */}
            </Block>
            <SectionMediumDivider />
            <CharityDetailSummary
              charityInfo={charityInfo}
              contactInfo={contactProps}
            />
            <SectionMediumDivider />
            <PurposeRecognition purposeRecognition={purposeRecognition} />
            <SectionMediumDivider smallMarginTop smallMarginBottom />
            <PermissionToPublish
              publish={publishName === "Yes" ? true : false}
            />
            <Block h={50} />
            <Step2Summary {...amountAllocation} />
            {this.props.scheduleType === "recurring" && (
              <>
                <SectionMediumDivider smallMarginTop />
                <ViewRecurSchedule
                  title="Recurring Grant Schedule"
                  scheduleData={scheduleData}
                />
              </>
            )}
            <SectionMediumDivider smallMarginBottom />
            <Heading title="Grant Agreement Payments" edit={false} />
            <Step3Summary payments={this.state.formattedPayments} />
          </div>
          <SectionMediumDivider smallMarginBottom />
          {payments && payments.length && (
            <PreviewLetters
              id={"multipage"}
              selectedCharityName={contact.legalName}
              selectedCharityAddress={contact}
              granteeOrgFirstName={contact.charityContactFirstName}
              granteeOrgLastName={contact.charityContactLastName}
              startDate={startDate}
              grantPurpose={purpose}
              payment={this.paymentFormatter()}
              grantAgreementAmount={grantAgreementAmount}
              grantRecognition={recognition}
              accountName={recognition.recognition}
              selectedCharityEin={contact.ein}
              codeValueMappingData={this.props.codeValueMappingData}
              advisors={this.props.advisors}
            />
          )}
          <SectionMediumDivider smallMarginBottom />
          <GrantGhostButton
            width={"auto"}
            onClick={() => this.goToPage("3")}
            id="btnViewAllAgreements"
          >
            View all Grants Agreements
          </GrantGhostButton>
        </FixedWidth>
      </ContentProvider>
    );
  }
}

ConfirmationPage.propTypes = {
  advisors: PropTypes.array,
  codeValueMappingData: PropTypes.object,
  contact: PropTypes.object,
  fetchAdvisors: PropTypes.func,
  getGrantAgreementData: PropTypes.func,
  grantAgreementAmount: PropTypes.string,
  grantAgreementEnteredDate: PropTypes.number,
  grantAgreementId: PropTypes.any,
  isGrantView: PropTypes.bool,
  newAgreement: PropTypes.func,
  noOfPayments: PropTypes.any,
  payments: PropTypes.array,
  purpose: PropTypes.object,
  recognition: PropTypes.object,
  scheduleType: PropTypes.string,
  startDate: PropTypes.any,
  status: PropTypes.object,
};

const mapStateToProps = (state) => ({
  ...confirmationPageDerivedStates(state.toJS()),
});

const mapDispatchToProps = (dispatch) => ({
  getGrantAgreementData: (data) => dispatch(postSubmitApi(data)),
  fetchAdvisors: (data) => dispatch(fetchAccountAdvisors(data)),
  newAgreement: (data) => dispatch(newAgreement(data)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ConfirmationPage)
);
